import { BACKEND_URL_PREFIX } from '../assets/const';
import { createNotification, getLastErrorNotificationTime } from '../components/Notifications/Notifications';
import { parseErrorMessage } from './errorMessage';

// Часть экшенов сама показывает тост об ошибке сразу после ответа.
// Общий тост ждёт это время и показывается, только если своего не было.
const NOTIFICATION_DELAY = 500;

const getUrl = (input) => (input instanceof Request ? input.url : String(input));

const isBackendRequest = (url) => Boolean(BACKEND_URL_PREFIX) && url.startsWith(BACKEND_URL_PREFIX);

const notifyUnlessHandled = (failedAt, message) => {
  setTimeout(() => {
    if (getLastErrorNotificationTime() < failedAt) createNotification('error', message);
  }, NOTIFICATION_DELAY);
};

// Глобально — только сбои, не зависящие от смысла запроса.
// 400, 404, 409 и прочие 4xx обрабатывает сам экшен.
const shouldNotify = (status) => status === 403 || status >= 500;

const getErrorMessage = async (response) => {
  // clone — тело оригинала должен прочитать экшен
  const text = await response.clone().text().catch(() => '');
  const fallback = response.status === 403 ? 'Недостаточно прав' : 'Ошибка сервера, попробуйте позже';
  return parseErrorMessage(text) || fallback;
};

// Защита от повторной обёртки при hot reload в деве
if (!window.fetch.isIntercepted) {
  const originalFetch = window.fetch.bind(window);

  const interceptedFetch = async (input, init) => {
    const url = getUrl(input);
    if (!isBackendRequest(url)) return originalFetch(input, init);

    let response;
    try {
      response = await originalFetch(input, init);
    } catch (error) {
      if (error.name !== 'AbortError') notifyUnlessHandled(Date.now(), 'Нет связи с сервером');
      throw error;
    }

    // 401 на /token — это неверный логин, его обрабатывает сам auth()
    if (response.status === 401 && url !== `${BACKEND_URL_PREFIX}/token`) {
      window.dispatchEvent(new CustomEvent('auth:expired'));
    } else if (shouldNotify(response.status)) {
      const failedAt = Date.now();
      getErrorMessage(response).then((message) => notifyUnlessHandled(failedAt, message));
    }

    return response;
  };

  interceptedFetch.isIntercepted = true;
  window.fetch = interceptedFetch;
}
